
export class LineBarAccessConfig {
  lineId?: number;
  lineName?: string;
  userId?: number;
  weight?: number;
  isExpanded?: boolean;
}
